/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './listActivitySubscriptions.defs'
export { main as default } from './listActivitySubscriptions.defs'
